import React, { Component } from 'react';

class UpdatesMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Atualizações de Dados </h2>
                <p>
                    Nesta página pode encontrar informações sobre as atualizações de dados.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Listagem dos dados atualizados</li>
                </ul>
            </div>
        );
    }
}
export default UpdatesMetadata;
